import "./Footer.scss";

const Footer = ()=>{
    return (
        <div className="footer">
            <p className="footer__copyright">Copyright &#169; VL Energy Ltd. 2024. All Rights Reserved.</p>
        </div>
    );
}

export default Footer;